import fs from 'node:fs'
import path from 'node:path'
import { fileURLToPath } from 'node:url'
import type { BetterstartConfigFile } from './types.js'

const CONFIG_FILE_NAME = 'admin.config.ts'

export function findConfigFile(cwd: string): string | undefined {
  const filePath = path.join(cwd, CONFIG_FILE_NAME)
  return fs.existsSync(filePath) ? filePath : undefined
}

export async function loadConfigFile(configPath: string): Promise<BetterstartConfigFile> {
  const { createJiti } = await import('jiti')

  const alias: Record<string, string> = {}
  try {
    alias['betterstart-cli'] = fileURLToPath(import.meta.resolve('betterstart-cli'))
  } catch {
    // Config files may not import from this package.
  }

  const jiti = createJiti(import.meta.url, { alias })
  const mod = await jiti.import(configPath)
  return ((mod as Record<string, unknown>).default || mod) as BetterstartConfigFile
}
